class CarouselV2 {
    constructor(c) {
        this.parent = c.parent
        this.isVideoIframe = this.parent.classList.contains('iframe-check') 
        this.dots = this.parent.querySelectorAll('.wu-carousel-dots');
        this.dotwrapper= this.parent.querySelector('.dot-wrapper');
        this.list = this.parent.querySelector('.tabpanel');
        // Track active dot at the class level to persist state across events
        this.activeDotNum = 0;
        this.init()
    }
    init() {
        this.addIframeOverlays();
        this.listeners();
        [].forEach.call(this.dots, function(el) {
            el.classList.remove("bk-grey-02");
        });
        this.handlerWindowResize();
    }

    addIframeOverlays() {
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (!isTouchDevice) return;
    
        const iframes = document.querySelectorAll('iframe');

        const cssStyles = "position: absolute; top: 0; width: 40%; height: 100%; background: transparent; z-index: 10; cursor: pointer;"
        
        if(this.isVideoIframe) {
            const iframeOverlay = document.createElement('div');
            iframeOverlay.classList.add('iframe-touch-overlay', 'position-absolute');
            iframeOverlay.style.cssText = `${cssStyles} left: 0;`;
    
            const iframeOverlay2 = document.createElement('div');
            iframeOverlay2.classList.add('iframe-touch-overlay');
            iframeOverlay2.style.cssText = `${cssStyles} left: 60%;`;
    
            this.list.appendChild(iframeOverlay);  
            this.list.appendChild(iframeOverlay2);  
        }
    
        iframes.forEach((iframe) => {
            // Make sure it's part of this carousel
            if (!this.list.contains(iframe)) return;
    
            // Avoid duplicate overlays
            if (iframe.parentElement.querySelector('.iframe-touch-overlay')) return;

            const parent = iframe.parentElement;
            const computedStyle = window.getComputedStyle(parent);
            if (computedStyle.position === 'static') {
                parent.style.position = 'relative';
            }
    
            
        });
    }

listeners() {
let touchstartX = 0;
let touchendX = 0;
const overlays = this.list.querySelectorAll('.iframe-touch-overlay');
this.dots.forEach((dot, idx) => {  
dot.setAttribute('data-num', idx);
dot.addEventListener('click', (e) => {
    // Ensure dataset number is converted to integer
    let clickedDotNum = parseInt(e.target.dataset.num);
    if(overlays?.length > 0) {
        overlays[0].style.left = ((clickedDotNum) * 100 )+ '%'; 
        overlays[1].style.left = ((clickedDotNum) * 100 + 60) + '%';
    }
    // Use strict comparison and class-level activeDotNum
    if (clickedDotNum === this.activeDotNum) {
        return;
    }
    else {
        let displayArea =  this.list.parentElement.clientWidth;
        const pixels = (document?.dir === 'rtl') ? (displayArea * clickedDotNum) : (-displayArea * clickedDotNum)
        this.list.style.transition = 'transform 1s ease';
        this.list.style.transform = 'translateX('+ pixels + 'px)';
        this.list.style.removeProperty("left");
        // Use class-level activeDotNum for consistent dot deactivation
        this.dots[this.activeDotNum].classList.remove('wu-carousel-dots-active');
        this.dots[clickedDotNum].classList.add('wu-carousel-dots-active');
        this.dots[clickedDotNum].classList.remove('bk-grey-02');
        //  Update activeDotNum at class level
        this.activeDotNum = clickedDotNum;
    }
    });
});   

this.list.addEventListener('touchstart', e => {
    touchstartX = e.changedTouches[0].screenX;
})    
this.list.addEventListener('touchend', e => {
    touchendX = e.changedTouches[0].screenX; 
    this.activedot = this.parent.querySelector('.wu-carousel-dots-active');
    // Convert to integer for calculations
    let currentNum = parseInt(this.activedot.dataset.num);
    if(overlays?.length > 0) {
        overlays[0].style.left = ((currentNum+1) * 100 )+ '%'; 
        overlays[1].style.left = ((currentNum+1) * 100 + 60) + '%';
    }

    let nextNum = currentNum;
    if (touchendX < touchstartX) {
        nextNum = currentNum + 1;
    } else if (touchendX > touchstartX) {
        nextNum = currentNum - 1;
    }
    if (nextNum < 0 || nextNum >= this.dots.length) {
        return;
    } else {
        let displayArea =  this.list.parentElement.clientWidth;
        console.log(displayArea);
        const pixels = (document?.dir === 'rtl')
                    ? (displayArea * nextNum)
                    : (-displayArea * nextNum);
        this.list.style.transition = 'transform 1s ease';
        this.list.style.transform = 'translateX('+ pixels + 'px)';
        this.dots.forEach((dot, i) => {
            this.dots[i].classList.remove('wu-carousel-dots-active');
            this.dots[i].classList.add('bk-grey-02');
        })
        this.dots[nextNum].classList.add('wu-carousel-dots-active');
        this.dots[nextNum].classList.remove('bk-grey-02');
        // Update class-level activeDotNum after swipe
        this.activeDotNum = nextNum;
    }
})

 window.addEventListener('resize', e => {
            this.handlerWindowResize()
        })
}

handlerWindowResize() {
        let windowWidth = document.documentElement.clientWidth;
        if(windowWidth >= 1024) {
            this.col= this.list.getAttribute("data-show-cols");
            if(Math.ceil(this.dots.length/this.col)>1 && this.dots.length>1){
            for (let i = 0; i < this.dots.length; i++) {
                if(this.dots[i].getAttribute("data-num")<Math.ceil(this.dots.length/this.col)){
                    this.dots[i].classList.add('d-inline-block')
                    this.dots[i].classList.remove('d-none')
                }
                else if(this.dots[i].getAttribute("data-num")>=Math.ceil(this.dots.length/this.col)){
                    this.dots[i].classList.remove('d-inline-block')
                    this.dots[i].classList.add('d-none')
                }
                    }
                }
                else{
                    for (let i = 0; i < this.dots.length; i++) {
                        this.dots[i].classList.remove('d-inline-block')
                        this.dots[i].classList.add('d-none')
                        }
                }
        } 
        if(windowWidth >= 768 &&  windowWidth< 1024) {
            this.col=this.list.getAttribute("data-show-cols-md");
            if(Math.ceil(this.dots.length/this.col)>1 && this.dots.length>1){
            for (let i = 0; i < this.dots.length; i++) {
                if(this.dots[i].getAttribute("data-num")<Math.ceil(this.dots.length/this.col)){
                    this.dots[i].classList.add('d-inline-block')
                    this.dots[i].classList.remove('d-none')
                }
                else if(this.dots[i].getAttribute("data-num")>=Math.ceil(this.dots.length/this.col)){
                    this.dots[i].classList.remove('d-inline-block')
                    this.dots[i].classList.add('d-none')
                }
                 }
                }
                else{
                    for (let i = 0; i < this.dots.length; i++) {
                        this.dots[i].classList.remove('d-inline-block')
                        this.dots[i].classList.add('d-none')
                        }
                }
        }
        if(windowWidth < 768) {
            for (let i = 0; i < this.dots.length; i++) {
                    this.dots[i].classList.add('d-inline-block')
                    this.dots[i].classList.remove('d-none')
                    }
        }
    }
}

let totSlider = document.querySelectorAll('.wu-carousel')
if (totSlider.length > 0) {
    for (let i = 0; i < totSlider.length; i++) {
        new CarouselV2({
            parent: totSlider[i]
        })
    }
}